// import suiteSVG from '../images/suite_crm.svg';
export default class IntegrationsService {

    static getIntegrations(localizedIntegrations) {
        const integrations =
            [
                {
                    type: 'linkedin',
                    name: localizedIntegrations.linkedIn.name,
                    category: 'SOCIAL',
                    description: localizedIntegrations.linkedIn.description,
                    icon: require('../images/linkedIn.png'),
                    route: '/settings/integrations/linkedIn',
                    adminOnly: false,
                },  
                {
                    type: 'cleverstory',
                    name: localizedIntegrations.cleverstory.name,
                    category: 'CRM',
                    description: localizedIntegrations.cleverstory.description,
                    icon: require('../images/cleverstory.png'),
                    route: '/settings/integrations/cleverstory',
                    adminOnly: true,
                },
                {
                    type: 'gmail',
                    name: localizedIntegrations.gmail.name,
                    category: 'EMAIL',
                    description: localizedIntegrations.gmail.description,
                    icon: require('../images/gmail_logo.png'),
                    route: '/settings/integrations/gmail',
                    adminOnly: false
                },
                {
                    type: 'outlook',
                    name: localizedIntegrations.outlook.name,
                    category: 'EMAIL',
                    description: localizedIntegrations.outlook.description,
                    icon: require('../images/outlook_logo.png'),
                    route: '/settings/integrations/outlook',
                    adminOnly: false
                },
                {
                    type: 'smtp',
                    name: localizedIntegrations.smtp.name,
                    category: 'EMAIL',
                    description: localizedIntegrations.smtp.description,
                    icon: require('../images/smtp_logo.png'),
                    route: '/settings/integrations/smtp',
                    adminOnly: false
                },
                {
                    type: 'salesforce_v2',
                    name: localizedIntegrations.salesforce.name,
                    category: 'CRM',
                    description: localizedIntegrations.salesforce.description,
                    icon: require('../images/salesforce.png'),
                    route: '/settings/integrations/salesforce',
                    adminOnly: false,
                    searchContacts: true
                },
                {
                    type: 'freshsales',
                    name: localizedIntegrations.freshsales.name,
                    category: 'CRM',
                    description: localizedIntegrations.freshsales.description,
                    icon: require('../images/freshsales_icon.png'),
                    route: '/settings/integrations/freshsales',
                    adminOnly: false,
                    searchContacts: false
                },
                {
                    type: 'hubspot',
                    name: localizedIntegrations.hubspot.name,
                    category: 'CRM',
                    description: localizedIntegrations.hubspot.description,
                    icon: require('../images/hubspotLogo.svg').default,  //while using require on svgs use default
                    route: '/settings/integrations/hubspot',
                    adminOnly: false,
                    searchContacts: true
                },
                {
                    type: 'pipedrive',
                    name: localizedIntegrations.pipedrive.name,
                    category: 'CRM',
                    description: localizedIntegrations.pipedrive.description,
                    icon: require('../images/pipedrive_logo.svg').default,
                    route: '/settings/integrations/pipedrive',
                    adminOnly: false,
                    searchContacts: true
                },
                {
                    type: 'klenty',
                    name: localizedIntegrations.klenty.name,
                    category: 'CADENCE',
                    description: localizedIntegrations.klenty.description,
                    icon: require('../images/klenty_logo.png'),
                    route: '/settings/integrations/klenty',
                    adminOnly: true
                },
                {
                    type: 'outreach',
                    name: localizedIntegrations.outreach.name,
                    category: 'CADENCE',
                    description: localizedIntegrations.outreach.description,
                    icon: require('../images/outreach_logo.svg').default,
                    route: '/settings/integrations/outreach',
                    adminOnly: false
                },
                {
                    type: 'intercom',
                    name: localizedIntegrations.intercom.name,
                    category: 'CHAT',
                    description: localizedIntegrations.intercom.description,
                    icon: require('../images/intercom.png'),
                    route: '/settings/integrations/intercom',
                    adminOnly: true
                },
                {
                    type: 'drift',
                    name: localizedIntegrations.drift.name,
                    category: 'CHAT',
                    description: localizedIntegrations.drift.description,
                    icon: require('../images/drift.svg').default,
                    route: '/settings/integrations/driftchat',
                    adminOnly: true
                },
                {
                    type: 'google_analytics',
                    name: localizedIntegrations.google_analytics.name,
                    category: 'ANALYTICS',
                    description: localizedIntegrations.google_analytics.description,
                    icon: require('../images/google_analytics.svg').default,
                    route: '/settings/integrations/google-analytics',
                    adminOnly: true
                },
                {
                    type: 'google_analytics_4',
                    name: localizedIntegrations.google_analytics_v4.name,
                    category: 'ANALYTICS',
                    description: localizedIntegrations.google_analytics_v4.description,
                    icon: require('../images/google_analytics.svg').default,
                    route: '/settings/integrations/google-analytics-4',
                    adminOnly: true
                },
                {
                    type: 'google_tag_manager',
                    name: localizedIntegrations.google_tag_manager.name,
                    category: 'TAG_MANAGER',
                    description: localizedIntegrations.google_tag_manager.description,
                    icon: require('../images/google_tag_manager.svg').default,
                    route: '/settings/integrations/google-tag-manager',
                    adminOnly: true
                },
                {
                    type: 'six_sense',
                    name: localizedIntegrations.six_sense.name,
                    category: 'SIX_SENSE',
                    description: localizedIntegrations.six_sense.description,
                    icon: require('../images/six_sense.png'),
                    route: '/settings/integrations/six-sense',
                    adminOnly: true
                },
                {
                    type: 'zoho_v2',
                    name: localizedIntegrations.zoho.name,
                    category: 'CRM',
                    description: localizedIntegrations.zoho.description,
                    icon: require('../images/zoho_logo.png'),
                    route: '/settings/integrations/zoho',
                    adminOnly: false,
                    searchContacts: true
                },
                {
                    type: 'ms_dynamics_v2',
                    name: localizedIntegrations.ms_dynamics.name,
                    category: 'CRM',
                    description: localizedIntegrations.ms_dynamics.description,
                    icon: require('../images/microsoft_dynamics_logo.png'),
                    route: '/settings/integrations/ms-dynamics',
                    adminOnly: false,
                    searchContacts: true
                },
                {
                    type: 'salesloft',
                    name: localizedIntegrations.salesloft.name,
                    category: 'CADENCE',
                    description: localizedIntegrations.salesloft.description,
                    icon: require('../images/salesloft_logo.png'),
                    route: '/settings/integrations/salesloft',
                    adminOnly: false,
                    searchContacts: false
                },
                {
                    type: 'marketo',
                    name: localizedIntegrations.marketo.name,
                    category: 'MARKETING_AUTOMATION',
                    description: localizedIntegrations.marketo.description,
                    icon: require('../images/marketo.png'),
                    route: '/settings/integrations/marketo',
                    adminOnly: false
                },
                {
                    type: 'slack',
                    name: localizedIntegrations.slack.name,
                    category: 'NOTIFICATIONS',
                    description: localizedIntegrations.slack.description,
                    icon: require('../images/slack.png'),
                    route: '/settings/integrations/slack',
                    adminOnly: false
                },
                {
                    type: 'external_script',
                    name: localizedIntegrations.external_script.name,
                    category: 'EXTERNAL_SCRIPT',
                    description: localizedIntegrations.external_script.description,
                    icon: require('../images/js_logo.png'),
                    route: '/settings/integrations/external-script',
                    adminOnly: true
                },
                {
                    type: 'pardot',
                    name: localizedIntegrations.pardot.name,
                    category: 'CRM',
                    description: localizedIntegrations.pardot.description,
                    icon: require('../images/pardot.png'),
                    route: '/settings/integrations/pardot',
                    adminOnly: false,
                    searchContacts: false
                },
                {
                    type: 'netsuite',
                    name: localizedIntegrations.netsuite.name,
                    category: 'CRM',
                    description: localizedIntegrations.netsuite.description,
                    icon: require('../images/netsuite.png'),
                    route: '/settings/integrations/netsuite',
                    adminOnly: false,
                    searchContacts: true
                },
            ];

      const integrationsV2 = ["zoho_v2", "ms_dynamics_v2", "salesforce_v2", "hubspot", "netsuite", "pardot"];

        return {
            integrations: integrations,
            integrationsV2: integrationsV2
        }
    }

    static getStoryBoardType(type) {

        if (type === 'LANDING_PAGE') {
            return 'Landing page';
        }
        else if (type === 'INTERACTIVE_CONTENT') {
            return 'Interactive experience';
        }
        else if (type === 'RESOURCE_CENTER') {
            return 'Resource center';
        }
        else if (type === 'SPATIAL') {
            return 'Spatial';
        }
        return '';
    }


}